module.exports = [{"id":"Anh Z","text":"Removal van and trailer"},{"id":"Gasta","text":"Forklift"}]


//////////////////
// WEBPACK FOOTER
// ./src/data/VehicleTypes.json
// module id = 485
// module chunks = 4